import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=046b2f73&scoped=true&lang=pug&"
import script from "./MenuList.vue?vue&type=script&lang=ts&"
export * from "./MenuList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046b2f73",
  null
  
)

export default component.exports